export const CONTACT_ID = 'contact'

export const [imageWidth, imageHeight] = [1024, 512]
